const EditIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6137_18772)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.9873 1.4119C11.4648 0.934507 12.1124 0.666358 12.7877 0.666443C13.4629 0.666528 14.1104 0.934839 14.5878 1.41235C15.0652 1.88986 15.3333 2.53746 15.3333 3.21268C15.3332 3.8879 15.0649 4.53543 14.5874 5.01283L13.1994 6.40102C13.1809 6.42555 13.1604 6.44909 13.1381 6.47143C13.1158 6.49376 13.0922 6.51417 13.0677 6.53266L5.68945 13.9121L5.68866 13.9128C5.45684 14.1439 5.17183 14.3146 4.85866 14.4099L1.95459 15.2905C1.7817 15.3424 1.59797 15.3466 1.4229 15.3026C1.24783 15.2586 1.08793 15.168 0.960179 15.0405C0.832426 14.9129 0.741584 14.7532 0.697289 14.5782C0.652993 14.4032 0.656897 14.2194 0.708586 14.0465L0.709414 14.0437L1.59008 11.1424L1.59063 11.1406C1.68667 10.8274 1.85818 10.5426 2.09008 10.3111C2.09026 10.311 2.09045 10.3108 2.09063 10.3106L9.46768 2.93189C9.48609 2.90754 9.5064 2.88416 9.5286 2.86196C9.55077 2.83979 9.5741 2.81952 9.59841 2.80113L10.9873 1.4119ZM10.0046 4.28072L3.0328 11.254L3.03205 11.2548C2.95485 11.3318 2.8977 11.4265 2.86562 11.5307C2.86554 11.531 2.86546 11.5312 2.86539 11.5315L2.16683 13.8328L4.47068 13.1342C4.57486 13.1025 4.66969 13.0458 4.74688 12.969C4.74673 12.9692 4.74704 12.9689 4.74688 12.969L11.7193 5.99551L10.0046 4.28072ZM12.6621 5.05263L10.9473 3.33781L11.93 2.35483C11.93 2.35486 11.9301 2.35479 11.93 2.35483C12.1574 2.12752 12.4659 1.99974 12.7875 1.99978C13.1091 1.99982 13.4175 2.12761 13.6449 2.35504C13.8723 2.58248 14 2.89092 13.9999 3.21252C13.9999 3.53411 13.8721 3.84252 13.6447 4.0699L12.6621 5.05263Z"
          fill="#015C9A"
        />
      </g>
      <defs>
        <clipPath id="clip0_6137_18772">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EditIcon;
